// extracted by mini-css-extract-plugin
export default {"container":"RetentionData_container__MsQYT"};